import { inject, Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { ActivatedRoute } from '@angular/router';
import {
  ADD_REGIONAL_CONFIGS,
  DELETE_REGIONAL_CONFIGS,
  GET_CURRENCIES,
  GET_REGIONAL_CONFIGS_LIST,
  UPDATE_REGIONAL_CONFIGS,
} from '../graphql/regional-configs.graphql';
import { ulid } from 'ulid';
import { RegionalConfigsModel } from '../model/regional-configs.model';
@Injectable({
  providedIn: 'root',
})
export class RegionalConfigService {
  private apollo = inject(Apollo);
  private route = inject(ActivatedRoute);

  getCurrencies() {
    return this.apollo.query<{ currencies: string[] }>({
      query: GET_CURRENCIES,
    });
  }

  listRegionalConfigs() {
    return this.apollo.query({
      query: GET_REGIONAL_CONFIGS_LIST,
      variables: {
        tenantId: this.route.snapshot.queryParamMap.get('tenant'),
      },
    });
  }

  deleteRegionalConfig(id: string) {
    return this.apollo.query({
      query: DELETE_REGIONAL_CONFIGS,
      variables: {
        id,
        tenantId: this.route.snapshot.queryParamMap.get('tenant'),
      },
    });
  }

  createRegionalConfig(input: Partial<RegionalConfigsModel>) {
    return this.apollo.mutate({
      mutation: ADD_REGIONAL_CONFIGS,
      variables: {
        input: {
          ...input,
          ignoredDaysOfWeek: input.ignoredDaysOfWeek || [],
          tenantId: this.route.snapshot.queryParamMap.get('tenant'),
          id: ulid(),
        },
      },
    });
  }

  updateRegionalConfig(id: string, input: Partial<RegionalConfigsModel>) {
    return this.apollo.mutate({
      mutation: UPDATE_REGIONAL_CONFIGS,
      variables: {
        id,
        input: {
          description: input.description,
          bankHolidays: input.bankHolidays || [],
          ignoredDaysOfWeek: input.ignoredDaysOfWeek || [],
          defaultPhoneRegionCode: input.defaultPhoneRegionCode,
          timetable: input.timetable,
        },
      },
    });
  }
}
